import script from "./FormPaymentHistoryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPaymentHistoryComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormPaymentHistoryComponent.vue?vue&type=style&index=0&id=8b739cc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b739cc4"]])

export default __exports__